import { render, staticRenderFns } from "./ExamTotalAnswers.vue?vue&type=template&id=4b6ade3e&scoped=true"
import script from "./ExamTotalAnswers.vue?vue&type=script&lang=js"
export * from "./ExamTotalAnswers.vue?vue&type=script&lang=js"
import style0 from "./ExamTotalAnswers.vue?vue&type=style&index=0&id=4b6ade3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ade3e",
  null
  
)

export default component.exports